export default __webpack_public_path__ + "static/media/thinkbots_main_logo.eeea19a8.svg";